'use strict';

import { StudijneProgramyStavPreJazyk } from "./studijne-programy-stav-pre-jazyk";
import { ZaznamTextu } from "./zaznam-textu";

export class RequestZKlienta {

  zaznamyTextu: ZaznamTextu[];
	studijneProgramyStavPreJazyk: StudijneProgramyStavPreJazyk[];
  /** jazyky dokumentov osoby, stud. program a podprogramu (pozor, nie stud. programov podprogramu),
   * pre ktore nehccem novy variant (cislo pred bodkou - "?.")
   */
  jazykyKdePouzivatelNechceVytvoritNovyVariant: string[];


  // /** jazyky dokumentov osoby, resp. stud. programu, kde chcem vytvorit novu verziu */
  // jazykyKdeChcemeNovuVerziuDokumentu: string[];

  // /** jazyky dokumentov podprogramu a stud. programy dokumentov, pre ktore chcem vytvorit novu verziu
  //  * - na pozicii 0 je zoznam jazykov podprogramu
  //  * - na pozicii 1 je zoznam stud. programov
  // */
  // jazykyDokumentovPPaStudProgramyKdeChcemNovuVerziu: string[][];

  /** verzia dokumentu je cislo za bodkou - ".?"), na rozdiel od variantu */
  chcemGenerovatNovuVerziuDokumentov: boolean;


}
